'use client';

import React from 'react';

interface ModalFooterProps {
  onCancel?: () => void;
  onPrimary?: () => void;
  cancelLabel?: string;
  primaryLabel?: string;
  primaryDisabled?: boolean;
  variant?: 'default' | 'fullWidthSubmit';
  loading?: boolean;
  loadingLabel?: string;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  onCancel,
  onPrimary,
  cancelLabel = 'Cancel',
  primaryLabel = 'Submit',
  primaryDisabled = false,
  variant = 'default',
  loading = false,
  loadingLabel,
}) => {
  const resolvedPrimaryLabel = loading ? (loadingLabel || primaryLabel) : primaryLabel;
  const isDisabled = primaryDisabled || loading;

  if (variant === 'fullWidthSubmit') {
    return (
      <div className="px-6 pt-2 pb-6">
        {onPrimary && (
          <button
            type="button"
            onClick={onPrimary}
            disabled={isDisabled}
            className="w-full bg-blue-500 hover:bg-blue-600 disabled:opacity-60 disabled:cursor-not-allowed text-white py-3 rounded-xl font-semibold text-sm transition-colors cursor-pointer"
          >
            {resolvedPrimaryLabel}
          </button>
        )}
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="mt-3 mx-auto block text-xs font-semibold text-gray-400 uppercase tracking-widest cursor-pointer"
          >
            {cancelLabel}
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="px-6 py-4 flex items-center justify-between border-t border-gray-100 rounded-b-2xl">
      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="text-sm font-medium text-gray-500 hover:text-gray-700 cursor-pointer"
        >
          {cancelLabel}
        </button>
      )}
      <div className="ml-auto">
        {onPrimary && (
          <button
            type="button"
            onClick={onPrimary}
            disabled={isDisabled}
            className="bg-blue-500 hover:bg-blue-600 disabled:opacity-60 disabled:cursor-not-allowed text-white px-5 py-2.5 rounded-xl text-sm font-semibold transition-colors cursor-pointer"
          >
            {resolvedPrimaryLabel}
          </button>
        )}
      </div>
    </div>
  );
};

